module.exports = "../dist/img/img_2-21.6feb.jpg";